import { call, put, select, takeEvery } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator, gridSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { ResponseCatalog } from 'Models'
import {
	RecommendationModel,
	recommendationsApi,
	recommendationsSlice,
	RecommendationsNS,
	recommendationsSelectors,
} from 'Pages/orders'

function* getAll(action: RecommendationsNS.getAll) {
	try {
		const { params, clear, callback } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		if (clear) {
			yield* put(recommendationsSlice.actions.clearAll())
		}
		const res = yield* call(recommendationsApi.getAll, params)
		const logsResponse = new ResponseCatalog<RecommendationModel>(res)
		logsResponse.entries = logsResponse.entries.map(
			(log): RecommendationModel => Deserialize(log, RecommendationModel)
		)
		if (!clear) {
			const oldLogs = yield* select(recommendationsSelectors.getAll)
			logsResponse.entries = [...oldLogs.entries, ...logsResponse.entries]
		}
		yield* put(recommendationsSlice.actions.setAll(logsResponse))
		yield* put(recommendationsSlice.actions.setRequestParams(params))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
		if (error.status === 403) {
			yield* put(recommendationsSlice.actions.setAll(new ResponseCatalog<RecommendationModel>()))
		}
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* updateOne(action: RecommendationsNS.updateOne) {
	try {
		const { id, recommendation } = action.payload
		if (id) {
			yield* call(recommendationsApi.updateOne, recommendation, id)
		} else {
			yield* call(recommendationsApi.createOne, recommendation)
		}
		const params = yield* select(recommendationsSelectors.getRequestParams)
		const recommendations = yield* call(recommendationsApi.getAll, params)
		yield* put(recommendationsSlice.actions.setAll(recommendations))
		yield* call(notifyMessageCreator, 'common.update.success', { data: [recommendation.name] })
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* deleteOne(action: RecommendationsNS.deleteOne) {
	try {
		yield* call(recommendationsApi.deleteOne, action.payload)
		const params = yield* select(recommendationsSelectors.getRequestParams)
		const recommendations = yield* call(recommendationsApi.getAll, params)
		yield* put(recommendationsSlice.actions.setAll(recommendations))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const sagaRecommendation = function* saga() {
	yield* takeEvery(recommendationsSlice.actions.getAll.type, getAll)
	yield* takeEvery(recommendationsSlice.actions.updateOne.type, updateOne)
	yield* takeEvery(recommendationsSlice.actions.deleteOne.type, deleteOne)
}
